import { useEffect, useState } from 'react';
import { minutesToHours, liveWorkingMinutes } from '@/utils/format';

// Renders today's working hours, ticking every second while the day is open so
// the number counts up live. Mirrors the server's check-out math via
// liveWorkingMinutes(). Isolated so only this text re-renders each tick, not the
// surrounding page. Pass a `format` fn to customise the output (default "Xh Ym").
export default function LiveWorkingHours({ att, format = minutesToHours }) {
  const running = !!att?.checkInAt && !att?.checkOutAt;
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!running) return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [running]);

  return format(liveWorkingMinutes(att, now));
}
